import fetch from "auth/FetchInterceptor";
import { AUTH_TOKEN } from "constants/AuthConstant";

const NotificationService = {};

NotificationService.getNotifications = function ({ page = 1, limit = 20 }) {
  return fetch({
    method: "get",
    url: `notification?page=${page}&limit=${limit}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

NotificationService.countUnread = function () {
  return fetch({
    method: "get",
    url: `notification/unread/count`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

NotificationService.markAsRead = function (notificationId) {
  return fetch({
    method: "patch",
    url: `notification/${notificationId}/read`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

NotificationService.markAllAsRead = function () {
  return fetch({
    method: "patch",
    url: `notification/read-all`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
    },
  });
};

export default NotificationService;
